"use client";
import Header from '../components/Header';
import Footer from '../components/Footer';
export default function ProductError({ reset }: { reset: () => void }) {
  return <div className="store-site"><Header /><main id="main-content" className="store-container store-section"><h1 className="editorial-title">We couldn’t load the products.</h1><p className="section-intro">Please try again in a moment, or contact the store for availability.</p><button className="store-button outline" onClick={reset}>Try again</button></main><Footer /></div>;
}
